import { render, staticRenderFns } from "./our-values.vue?vue&type=template&id=1d960d56&"
import script from "./our-values.vue?vue&type=script&lang=js&"
export * from "./our-values.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SocialShareBtns: require('/app/components/social-share-btns.vue').default,BannerType1: require('/app/components/content-elements/banner-type-1.vue').default,Style1Pl: require('/app/components/loading-placeholders/style1-pl.vue').default,FullWidthVideo: require('/app/components/video-elements/fullWidthVideo.vue').default,MasonrySet: require('/app/components/masonry-set.vue').default})
